import ExternalLink from '../../../components/ExternalLink'
import { Page } from '../../types'

type TricksPyomoProps = { }
const render = () => {
    return <>
    <h3>Exporting a model</h3>
    <p>
        You can simply export a model using <code>model.write(filename).</code> Pyomo recognizes
        the MPS and LP file extensions. By default, all variable and constraint names will be
        anonymized similar to the Gurobi REW format. If you want to export the original names, use
        <code>model.write(filename, io_options={"{'symbolic_solver_labels': True}"})</code>
    </p>
    <h3>Customizing the Gurobi environment</h3>
    <p>
        You can't influence how Pyomo creates the underlying Gurobi environment. To use settings
        for Web License Service, Compute Server, Token Server or Instant Cloud you will need to 
        have a license file that contains the settings; Gurobi will read this file when setting up
        your environment through Pyomo.
    </p>
    <h3>Setting model parameters</h3>
    <p>
        You can set Gurobi parameters using <code>opt.options['parameterName'] = value</code> syntax.
    </p>    
    <h3>Showing Gurobi log output</h3>
    <p>
        To view Gurobi log output when solving your model, add the <code>tee</code> parameter
        : <code>opt.solve(model, tee=True)</code>. If you want to write the log to a file,
        add the <code>keepfiles</code> and <code>logfile</code> arguments: <code>opt.solve(model, keepfiles=True, logfile='gurobi.log')</code>
    </p>
    <h3>Accessing gurobipy functionality</h3>
    <p>
        Pyomo is an abstraction layer over gurobipy and does not expose all functionality.
        However, you can still acccess the underlying gurobipy <code>Model</code> object
        by accessing <code>opt._solver_model</code>:
        <pre>
        import pyomo.environ as pyo<br/>
        model = pyo.ConcreteModel()<br/>
        opt = pyo.SolverFactory('gurobi_direct', model=model)<br/>
        opt._solver_model.computeIIS()<br/>
        </pre>
    </p>        
    <h3>Disposing your environment</h3>
    <p>
        The only way to explicitly dispose your environment and release any
        WLS or Token Server tokens, is as follows:
        <pre>
            opt._solver_model.dispose()
            import gurobipy as gp
            gp.disposeDefaultEnv()
        </pre>
    </p>
    <h3>Picking a Pyomo-Gurobi interface</h3>
    <p>
        Note that Pyomo provides multiple interfaces to Gurobi. The basic
        interface is <code>gurobi_direct</code> which calls <code>gurobipy</code>
        under the hood. If you want to solve multiple versions of the same model
        while making changes between runs, you can use <code>gurobi_persistent</code>. 
        Keep in mind you must explicitly make the changes <em>and</em> tell the
        solver what changed. And then there is the <code>APPSI</code> package which
        also provides an <ExternalLink href="https://pyomo.readthedocs.io/en/stable/library_reference/appsi/appsi.solvers.gurobi.html">interface</ExternalLink> for Gurobi;
        this interface automatically detects changes and has more efficient ways
        to update the underlying Gurobi model. Finally, there are ways to let Pyomo
        interact with Gurobi through LP/MPS files but we recommend not using this 
        approach as it is less performant.
    </p>
    </>
}

const TricksPyomo : Page<TricksPyomoProps> = { title: 'Tips and tricks for Pyomo', key: 'tricks-pyomo', render }

export default TricksPyomo